"use client";

import {
  GetInvolvedFormCategoryItem,
} from "@/models/get-involved";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/firebase";
import { Collections } from "../utils/collections";
import {
  defaultMap,
} from "../utils/utility-functions";


export async function getGetInvolvedForms() {
  try {
    const collectionRef = collection(
      db,
      Collections.GET_INVOLVED_FORMS
    );
    const querySnapshot = await getDocs(collectionRef);
    const items = querySnapshot.docs.map((doc) =>
      defaultMap<GetInvolvedFormCategoryItem>(doc)
    );

    items.push({
      id: "",
      category: "general",
      getInvolvedTitle: "Hotel Bookings",
      adminFormsTitle: "Hotel Bookings",
      link: "hotel-booking",
      isActive: false,
    })

    items.push({
      id: "",
      category: "general",
      getInvolvedTitle: "Marketing Site Popups",
      adminFormsTitle: "Marketing Site Popups",
      link: "marketing-site-popup",
      isActive: false,
    })

    return items;
  } catch (e) {
    return [];
  }
}

export async function saveGetInvolvedFormCategoryItem(
  document: GetInvolvedFormCategoryItem
) {
  try {
    const docRef = document.id
      ? await updateGetInvolvedFormCategoryItem(document)
      : await addGetInvolvedFormCategoryItem(document);
    const docSnapshot = await getDoc(docRef);
    return defaultMap<GetInvolvedFormCategoryItem>(docSnapshot);
  } catch (e) {
    return null;
  }
}

export async function addGetInvolvedFormCategoryItem(
  document: GetInvolvedFormCategoryItem,
) {
  const collectionRef = collection(
    db,
    Collections.GET_INVOLVED_FORMS
  );
  const { id, ...rest } = document;
  return await addDoc(collectionRef, { ...rest });
}

export async function updateGetInvolvedFormCategoryItem(
  document: GetInvolvedFormCategoryItem,
) {
  const docRef = doc(
    db,
    Collections.GET_INVOLVED_FORMS,
    document.id
  );
  const { id, ...rest } = document;
  await updateDoc(docRef, { ...rest });
  return docRef;
}

export async function deleteGetInvolvedFormCategoryItem(
  categoryItemId: string
) {
  try {
    const docRef = doc(
      db,
      Collections.GET_INVOLVED_FORMS,
      categoryItemId
    );
    await deleteDoc(docRef);
    return true;
  } catch (e) {
    return false;
  }
}
